/*
Normally you would use an .env file and access them in the code with process.env.x
Here we define them as constant and import then into js files when we need them
*/
import runtimeEnv from '@mars/heroku-js-runtime-env';
const env = runtimeEnv();

let REACT_APP_SITE_KEY = 'sXg5csdfF24F5aDFSDFx';
let REACT_APP_RESOURCE_URL = 'http://dev.mercurycart.ca/';
let REACT_APP_API_URL = 'http://dev.mercurycart.ca/api/';
let REACT_APP_STRIPE_KEY =
	'pk_test_51HuLsQDycTv2aQZkn1BBn2TO0CpAwFNLU8VFcLbKzOqzvm0bLZCoST6JwTzIMXRqoiY7OxLVNKaB9dpYleran73G0057S2s5ML';
let REACT_APP_RECAPTCHA_KEY = '6LdD7GcUAAAAAC9AwCnuA7mpAqLTu7d_GsOhWdQg';

// Flexiti Keys
let REACT_APP_FLEXITI_SECRET = '2b540f8a-2196-434b-98e8-a42f989a0996';
let REACT_APP_FLEXITI_CLIENTID = 'flexitidemo';
let REACT_APP_FLEXITI_ENV = 'training';
let REACT_APP_FLEXITI_SDK_URL = 'https://onlineapi-training.flexiti.fi/public/libs/SDK/js/flexiti-sdk-0.0.1.js'
let REACT_APP_GOOGLE_ANALYTICS_CODE = 'GTM-PBWSGNP';

// // Global Payments Vars
// let REACT_APP_HASHING_PASS = '3C!FVQzBg0SD*MU3BZWP@TGE(Df8';
// let REACT_APP_HASHING_SALT_PASS = 'Kop0fnd4Gozm4RKF7CTW61Y5cp5t';

// We need to check if we are serving on the server or client/browser
// If on the client, we have what we need.
// If on the server, then we need to use the dotenv package
let finalEnv = {};
if (!env.REACT_APP_SITE_KEY) {
	require('dotenv').config();
	finalEnv = process.env;
} else {
	finalEnv = env;
}

if (process.env.NODE_ENV === 'production') {
	REACT_APP_SITE_KEY = finalEnv.REACT_APP_SITE_KEY;
	REACT_APP_RESOURCE_URL = finalEnv.REACT_APP_RESOURCE_URL;
	REACT_APP_API_URL = finalEnv.REACT_APP_API_URL;
	REACT_APP_STRIPE_KEY = finalEnv.REACT_APP_STRIPE_KEY;
	REACT_APP_RECAPTCHA_KEY = finalEnv.REACT_APP_RECAPTCHA_KEY;
	REACT_APP_FLEXITI_SECRET = finalEnv.REACT_APP_FLEXITI_SECRET;
	REACT_APP_FLEXITI_CLIENTID = finalEnv.REACT_APP_FLEXITI_CLIENTID;
	REACT_APP_FLEXITI_ENV = finalEnv.REACT_APP_FLEXITI_ENV;
	REACT_APP_FLEXITI_SDK_URL = finalEnv.REACT_APP_FLEXITI_SDK_URL;
	REACT_APP_GOOGLE_ANALYTICS_CODE = finalEnv.REACT_APP_GOOGLE_ANALYTICS_CODE;
	// REACT_APP_HASHING_PASS = finalEnv.REACT_APP_HASHING_PASS;
	// REACT_APP_HASHING_SALT_PASS = finalEnv.REACT_APP_HASHING_SALT_PASS;
}

// console.log('vars: ', finalEnv.REACT_APP_API_URL)

export {
	REACT_APP_SITE_KEY,
	REACT_APP_RESOURCE_URL,
	REACT_APP_API_URL,
	REACT_APP_STRIPE_KEY,
	REACT_APP_RECAPTCHA_KEY,
	REACT_APP_FLEXITI_SECRET,
	REACT_APP_FLEXITI_CLIENTID,
	REACT_APP_FLEXITI_ENV,
	REACT_APP_FLEXITI_SDK_URL,
	REACT_APP_GOOGLE_ANALYTICS_CODE,
	// REACT_APP_HASHING_PASS,
	// REACT_APP_HASHING_SALT_PASS,
};



// WEBPACK FOOTER //
// ./src/shared/vars.js